export default __webpack_public_path__ + "static/Private-Cloud-63aca22e4bbe8516f708978be7fb2e52.webp";